import React, {createContext, FC, useContext, useState} from "react";
import {Alert} from "@material-tailwind/react";

export type ToastContextProviderProps = {
    children?: React.ReactNode,
}

export type ToastInterface = {
    show: (message: string | JSX.Element, className?: string) => void
}

const ToastContext = createContext<ToastInterface|null>(null);

const useToastContext = () => {
    const context = useContext(ToastContext);

    if (context === undefined) {
        throw new Error("useToastContext was used outside of its Provider");
    }

    return context;
};

const ToastContextProvider: FC<ToastContextProviderProps>  = ({children}: ToastContextProviderProps) => {
    const [message, setMessage] = useState<string | JSX.Element>('');
    const [cl, setClass] = useState<string>('');

    const showToast = (msg: string | JSX.Element, className?: string) => {
        setMessage(msg);
        setClass(className ?? '');

        setTimeout(() => setMessage(''), 5000);
    }


    return (
        <ToastContext.Provider value={{show: showToast}}>
            {message ? <Alert className={`z-[999] rounded-md font-medium text-white w-auto fixed right-2 top-2 ${cl}`}>
                {message}
            </Alert> : ''}
            {children}
        </ToastContext.Provider>
    );
};

export {useToastContext, ToastContextProvider};
